import React, { useEffect, useState } from "react";
import { IntlProvider } from "react-intl";
import { connect } from "react-redux";

import IntlUtils from "services/intl/utils";

type Props = {
  children?: React.ReactNode;
  intlOverrides: string[];
};

interface LocaleDataTypes {
  messages: { [key: string]: string };
  formats: any;
}

function IntlWrapper({ children, intlOverrides }: Props): JSX.Element {
  const [locale] = useState(IntlUtils.getDateLocale());
  const [localeData, setLocaleData] = useState<LocaleDataTypes | undefined>();

  useEffect(() => {
    async function InitializeLocaleDataFromLocale() {
      const localesData: { [key: string]: LocaleDataTypes } =
        await IntlUtils.initialize(locale, intlOverrides);
      setLocaleData(localesData?.[locale]);
    }

    InitializeLocaleDataFromLocale();
  }, [locale, intlOverrides]);

  if (!localeData) return <></>;

  return (
    <IntlProvider
      key={locale}
      messages={localeData?.messages}
      formats={localeData?.formats}
      locale={locale}
      defaultLocale={IntlUtils.DEFAULT_LOCALE}
    >
      {children}
    </IntlProvider>
  );
}

const mapStateToProps = (state: any) => ({
  intlOverrides: state.Intl.intlOverrides,
});

export default connect(mapStateToProps)(IntlWrapper);
